export const MANUAL_RESERVATION_CODE_MAX_LEN = 10
